export const dynamicRows: string[] = [ 'status' ]
export const realTimeTableKey = 'GetDataByUser'

import i18n from '@/i18n'
import type { TableAlignmentType } from '@/types/alignment'

export interface RealtimeDynamicColumn {
    prop: string
    fixed: boolean
    align: TableAlignmentType
    label: string
    width?: string
    sortable?: boolean
}

// Base column config without label
interface BaseColumnConfig {
    prop: string
    fixed: boolean
    align: TableAlignmentType
    width?: string
    sortable?: boolean
}

export const PropNames = {
    ONLINE_USER_ID: 'online_user_id',
    REPRESENTANT: 'representant',
    USER_NAME: 'user_name',
    EXTENSION_NAME: 'extension_name',
    EXTENSION_ID: 'extension_id',
    STATUS: 'status',
    STATUS_DURATION: 'status_duration',
    CALLER_INFO: 'caller_info',
    CALLER_PHONE: 'caller_phone',
    CALL_INFO: 'call_info',
} as const

// Base config without labels - labels are added dynamically via getDynamicColumns()
const dynamicColumnsBase: BaseColumnConfig[] = [
    {
        prop: PropNames.ONLINE_USER_ID,
        fixed: false,
        align: 'center',
    },
    {
        prop: PropNames.REPRESENTANT,
        fixed: false,
        align: 'center',
    },
    {
        prop: PropNames.USER_NAME,
        fixed: false,
        align: 'center',
    },
    {
        prop: PropNames.EXTENSION_NAME,
        fixed: false,
        align: 'center',
    },
    {
        prop: PropNames.EXTENSION_ID,
        fixed: false,
        align: 'center',
    },
    {
        prop: PropNames.STATUS,
        fixed: false,
        align: 'center',
    },
    {
        prop: PropNames.STATUS_DURATION,
        fixed: false,
        align: 'center',
        width: '250px',
    },
    {
        prop: PropNames.CALLER_INFO,
        fixed: false,
        align: 'center',
        sortable: false,
    },
    {
        prop: PropNames.CALLER_PHONE,
        fixed: false,
        align: 'center',
        sortable: false,
    },
    {
        prop: PropNames.CALL_INFO,
        fixed: false,
        align: 'center',
        sortable: false,
    },
]

// Helper function to generate column with translated label at runtime
function generateColumnWithLabel (column: BaseColumnConfig): RealtimeDynamicColumn {
    return {
        ...column,
        label: i18n.global.t(`widget.realtimeTable.column.${column.prop}`) as string,
    }
}

// Returns columns with translated labels - call at runtime when translations are available
export function getDynamicColumns (): RealtimeDynamicColumn[] {
    return dynamicColumnsBase.map(generateColumnWithLabel)
}
